var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { Box, C, IconButton, PlusIcon, translate, useModal, } from '@lucidlink/uicore';
import { AddWorkspaceModal } from './AddWorkspaceModal';
import styles from '../WorkspaceBar.module.css';
export const AddWorkspaceButton = () => {
    _react_refresh_temp_2();
    const { closeModal: closeAddWorkspaceModal, openModal: openAddWorkspaceModal, } = useModal();
    const onClick = useCallback(() => {
        openAddWorkspaceModal({
            content: _jsx(AddWorkspaceModal, { closeModal: closeAddWorkspaceModal }),
        });
    }, [closeAddWorkspaceModal, openAddWorkspaceModal]);
    return (_jsx(Box, { className: styles.BarItemWrapper, padding: "s", children: _jsx(IconButton, { "aria-label": translate('Add Workspace'), className: C(styles.BarItemHideable), "data-testid": "add-workspace", Icon: PlusIcon, kind: "secondary", onClick: onClick, size: "medium" }) }));
};
_react_refresh_temp_1 = AddWorkspaceButton;
$RefreshReg$(_react_refresh_temp_1, "AddWorkspaceButton");
_react_refresh_temp_2(AddWorkspaceButton, "j/Nf/r92nEU9uo7SOt6CRlur0pU=", false, () => [useModal]);
